import en from './en';
import ru from './ru';

export { en, ru };



// WEBPACK FOOTER //
// ./src/translations/index.js